import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Toast, toastTypes } from 'src/app/core/services/toast'

import { usePortfolioNewsDetail } from '../hooks/use-portfolio-news-detail'
import { PortfolioNewsDetailSkeleton } from './skeleton'
import { PortfolioNewsDetailTemplate } from './template'

const PortfolioNewsDetail = (): React.JSX.Element | null => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { articleId } = useParams<{ articleId: string }>()
  const { article, relatedArticles, isLoading } = usePortfolioNewsDetail()

  useEffect((): void => {
    if (isLoading || article || !articleId) {
      return
    }

    Toast.notify({
      type: toastTypes.ERROR,
      title: t('portfolioNews.detail.loadErrorToastTitle'),
      message: t('portfolioNews.detail.loadErrorToastMessage'),
      options: { toastId: `portfolio-news-detail-missing-${articleId}` },
    })

    const canGoBack =
      typeof window !== 'undefined' && window.history.state?.idx > 0

    if (canGoBack) {
      navigate(-1)
    } else {
      navigate('/portfolio-news', { replace: true })
    }
  }, [article, articleId, isLoading, navigate, t])

  if (!article || isLoading) {
    return <PortfolioNewsDetailSkeleton />
  }

  return (
    <PortfolioNewsDetailTemplate
      article={article}
      relatedArticles={relatedArticles}
    />
  )
}

export default PortfolioNewsDetail
